import type { LootType } from "./types";

/**
 * The loot catalogue. Every island's quay holds copies of these. Geometry is
 * the visual language: anything with a flat, load-bearing top (`stackable`)
 * can carry more loot; anything with a domed lid, a fuse, a ring or a barrel
 * shape carries nothing. Values are gold — tuned with scripts/tune-levels.ts
 * so the value-first grab provably falls short from island 2 on.
 */
export const LOOT: Record<string, LootType> = {
  sugar:   { key: "sugar",   name: "Sugar Crate",    emoji: "📦", w: 1, d: 1, h: 1, value: 8,  stackable: true },
  rum:     { key: "rum",     name: "Rum Barrel",     emoji: "🛢️", w: 1, d: 1, h: 1, value: 12, stackable: true },
  powder:  { key: "powder",  name: "Powder Keg",     emoji: "🧨", w: 1, d: 1, h: 1, value: 16, stackable: false },
  cage:    { key: "cage",    name: "Caged Parrot",   emoji: "🦜", w: 1, d: 1, h: 1, value: 22, stackable: false },
  muskets: { key: "muskets", name: "Musket Crate",   emoji: "⚔️", w: 2, d: 1, h: 1, value: 20, stackable: true },
  chest:   { key: "chest",   name: "Treasure Chest", emoji: "💎", w: 2, d: 1, h: 1, value: 34, stackable: false },
  planks:  { key: "planks",  name: "Oak Planks",     emoji: "🪵", w: 3, d: 1, h: 1, value: 15, stackable: true },
  silk:    { key: "silk",    name: "Silk Bales",     emoji: "🧵", w: 2, d: 2, h: 1, value: 36, stackable: true },
  cannon:  { key: "cannon",  name: "Bronze Cannon",  emoji: "💣", w: 3, d: 1, h: 1, value: 48, stackable: false },
  idol:    { key: "idol",    name: "Golden Idol",    emoji: "🗿", w: 1, d: 1, h: 2, value: 42, stackable: false },
  tea:     { key: "tea",     name: "Tea Chest",      emoji: "🍵", w: 2, d: 1, h: 2, value: 30, stackable: true },
};
